import { FORM_REQUIRED_FIELD_ERROR } from "constants/strings";
import { IRule, RuleCondition } from "models/rule/rule.model";
import * as Yup from "yup";

export enum CreateRuleAppliesTo {
  "CONDITIONAL" = "CONDITIONAL",
  "ALL" = "ALL",
}

export enum CreateRuleAction {
  "BLOCK" = "BLOCK",
  "ASSIGN" = "ASSIGN",
  "PUT_INTO_TO_FIX" = "PUT_INTO_TO_FIX",
}

export const CreateRuleValidationSchema = Yup.object({
  name: Yup.string().required(FORM_REQUIRED_FIELD_ERROR),
  appliesTo: Yup.mixed().oneOf(Object.values(CreateRuleAppliesTo)),
  action: Yup.mixed().oneOf(Object.values(CreateRuleAction)),
  shippingWhitelistId: Yup.string()
    .nullable()
    .when("action", {
      is: CreateRuleAction.ASSIGN,
      then: Yup.string().required(FORM_REQUIRED_FIELD_ERROR),
    }),
  carrierId: Yup.string()
    .nullable()
    .when("action", {
      is: CreateRuleAction.ASSIGN,
      then: Yup.string().required(FORM_REQUIRED_FIELD_ERROR),
    }),
  conditions: Yup.array().when("appliesTo", {
    is: CreateRuleAppliesTo.CONDITIONAL,
    then: Yup.array().of(
      Yup.object().shape({
        condition: Yup.string(),
        operator: Yup.string(),
        value: Yup.mixed().when("operator", {
          is: (op) => op === "in" || op === "notIn",
          then: Yup.array()
            .of(Yup.string().required("Value cannot be empty"))
            .min(1, "Must have at least one value")
            .required("Value is required"),
          otherwise: Yup.string().required("Value is required"),
        }),
      })
    ),
  }),
});

export type CreateRuleFormValues = {
  name: string;
  conditions: RuleCondition[];
  appliesTo: CreateRuleAppliesTo;
  carrierId: string;
  shippingWhitelistId: IRule["id"];
  blockShipmentCreation: boolean;
  putIntoToFix: boolean;
  useImporterOfRecord: boolean;
};

export type CreateRuleRequestDto = Omit<
  CreateRuleFormValues,
  "appliesTo" | "carrierId"
>;
